import { z } from 'zod';
/**
 * Activate Partner Sales Response Schema
 * POST /api/v2/partner/members/:userId/activate-sales
 * Links the Bliks partner user to a HubSpot contact in the partner company so it
 * can submit leads (the n8n intake attributes via the acquirer contact id).
 * `created` is true when a new HubSpot contact was created from the user data,
 * false when an existing company contact (matched by email) was linked.
 */ export const ActivatePartnerSalesResponseSchema = z.object({
    success: z.literal(true),
    contactId: z.string(),
    created: z.boolean()
});

//# sourceMappingURL=activate-partner-sales.schema.js.map